/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';


class AssignmentsService {


    getGradableQuestions(classUID){
        return ApplicationServices.call(Constants.GET_GRADABLE_QUESTIONS  ,{classUID:classUID}).then(function(response){
            Action.update(Constants.GET_GRADABLE_QUESTIONS , response.gradableActions)
        });
    }

    getAssignmentLibrary(curriculumUid, languageUid){
        return ApplicationServices.call(Constants.GET_ASSIGNMENT_LIBRARY, {curriculumUid:curriculumUid, languageUid:languageUid}).then(function(response){
            Action.update(Constants.GET_ASSIGNMENT_LIBRARY , response.assignments)
        });
    }

    getGradedQuestions(classUID){
        return ApplicationServices.call(Constants.GET_GRADED_QUESTIONS  ,{classUID:classUID}).then(function(response){
            Action.update(Constants.GET_GRADED_QUESTIONS , response.gradableActions)
        });
    }

    getGradableQuestionsIndividual(key1, key2, key3, key4, key5, key6, key7){
        return ApplicationServices.call(Constants.GET_GRADED_QUESTIONS_INDIVIDUAL  ,{
            key1:key1,
            key2:key2,
            key3:key3,
            key4:key4,
            key5:key5,
            key6:key6,
            key7:key7,
        }).then(function(response){
            return response;
        });
    }

    addNewAssignment(homeworkName, ietf, toDate, fromDate, isRepeatable, 
                overallData,totalClass, studentsOnly, comment, isFavourite) {
        return ApplicationServices.call(Constants.ADD_NEW_ASSIGNMENT , 
            {homeworkName:homeworkName,ietf:ietf,toDate:toDate,fromDate:fromDate,
                isRepeatable:isRepeatable,overallData:overallData, 
                totalClass:totalClass, studentsOnly:studentsOnly, comment:comment, isFavourite:isFavourite}
            ).then(function(response){
            Action.update(Constants.ADD_NEW_ASSIGNMENT , response);
            return response;
        });
    }

    editAssignment(uid , homeworkName, ietf, toDate, fromDate, isRepeatable,
                   overallData,totalClass, studentsOnly, comment) {
        return ApplicationServices.call(Constants.EDIT_ASSIGNMENT ,
            {uid:uid , homeworkName:homeworkName,ietf:ietf,toDate:toDate,fromDate:fromDate,
                isRepeatable:isRepeatable,overallData:overallData,
                totalClass:totalClass, studentsOnly:studentsOnly, comment:comment}
        ).then(function(response){
                Action.update(Constants.ADD_NEW_ASSIGNMENT , response);
                return response;
            });
    }

    duplicateAssignment(homeworkUid, homeworkName, toDate, fromDate, 
            isRepeatable, totalClass, studentsOnly, comment) {
        return ApplicationServices.call(Constants.DUPLCATE_ASSIGNMENT , 
            {homeworkID:homeworkUid,name:homeworkName,dueDTS:toDate,setDTS:fromDate,
                isRepeatable:isRepeatable,
                totalClass:totalClass, studentsOnly:studentsOnly, comment:comment}
            ).then(function(response){
            Action.update(Constants.DUPLCATE_ASSIGNMENT , response);
            return response;
        });
    }
    
    duplicateLibraryAssignment(homeworkUid,homeworkName, toDate, fromDate, 
        isRepeatable, totalClass, studentsOnly, comment, languageID) {
            return ApplicationServices.call(Constants.DUPLCATE_LIBRARY_ASSIGNMENT , 
                {homeworkID:homeworkUid,name:homeworkName,dueDTS:toDate,setDTS:fromDate,
                    isRepeatable:isRepeatable,
                    totalClass:totalClass, studentsOnly:studentsOnly, comment:comment, languageID:languageID}
                ).then(function(response){
                Action.update(Constants.DUPLCATE_LIBRARY_ASSIGNMENT , response);
                return response;
            });
        }

    getHomeworkFeatures(homeworkID){
        return ApplicationServices.call(Constants.GET_HOMEWORKS_FEATURES , {homeworkID:homeworkID}).then(function(response){
            return response.features;
        })
    }

    getUsersCompleted(homeworkID) {
        return ApplicationServices.call(Constants.GET_USERS_COMPLETED , {homeworkID:homeworkID}).then(function(response){
            Action.update(Constants.GET_USERS_COMPLETED , response.users);
            return response.users
        });
    }
    
    getScores(homeworkID){
        return ApplicationServices.call(Constants.GET_SCORES , {homeworkID:homeworkID}).then(function(response){
            return response;
        })
    }

    setArchived(homeworkID)
    {
        return ApplicationServices.call(Constants.GET_SCORES , {homeworkID:homeworkID}).then(function(response){
            return response;
        })
    }

    setArchived(homeworkID , archived){
        return ApplicationServices.call(Constants.SET_ARCHIVED , {homeworkID:homeworkID , archived:archived}).then(function(response){
            return response.features;
        })
    }

    setDeleted(homeworkID , archived){
        return ApplicationServices.call(Constants.SET_DELETED , {homeworkID:homeworkID , archived:archived}).then(function(response){
            return response.features;
        })
    }

    gradeQuestion(grade, keys, isHomework, writtenFeedback, audioFeedbackData, cannotGrade) {
        return ApplicationServices.call(Constants.ADD_NEW_FEEDBACK,{
            grade:grade, keys:keys, isHomework:isHomework, writtenFeedback:writtenFeedback,
            audioFeedbackData:audioFeedbackData,
            cannotGrade:cannotGrade
        })
    }

    gradeQuestionExamTest(grade, keys, writtenFeedback, audioFeedbackData) {
        return ApplicationServices.call(Constants.ADD_NEW_FEEDBACK_EXAM,{
            grade:grade, keys:keys, writtenFeedback:writtenFeedback,
            audioFeedbackData:audioFeedbackData
        })
    }

    scoreSummary(key){
        return ApplicationServices.call(Constants.SCORE_SUMMARY, { key:key }).then(function(response){
            return response;
        });

    }

    getSingleLibraryAssignment(homeworkUid, curriculumUid){
        return ApplicationServices.call(Constants.GET_LIBRARY_SINGLE, {homeworkUid:homeworkUid, curriculumUid:curriculumUid}).then(function(response){
            return response.homework;
        });
    }
}

export default new AssignmentsService();